(function (w) {
  'use strict';
  const storageKey = 'joolme-il-cart-edit-v1';
  const text = value => String(value == null ? '' : value);
  function tags(item) {
    const raw = item && item.properties && (item.properties._diamond || item.properties.diamond);
    let diamond = raw;
    if (typeof raw === 'string') { try { diamond = JSON.parse(raw); } catch (_) { diamond = null; } }
    const result = {};
    ((diamond && diamond.tags) || []).forEach(tag => { const i = tag.indexOf(':'); if (i > 0) result[tag.slice(0, i)] = tag.slice(i + 1); });
    return result;
  }
  function specification(ring, diamond) {
    const p = ring.properties || {}, d = tags(diamond);
    return {metal: text(p._option1).split('|')[0], karat: text(p._option1).split('|')[1], side: text(p._option2).replace('carat|', ''), size: text(p['גודל'] || p['_גודל'] || p.size), shape: (()=>{let v=diamond?.properties?._variant || {};try{if(typeof v==='string')v=JSON.parse(v);}catch(_){}return text(v.option1 || diamond?.variant_title);})(), origin: d.DiamondType || '', weight: d.DiamondSize || '', colour: d.DiamondColor || '', clarity: d.DiamondCleanlines || ''};
  }
  function context() {
    try {
      const c = JSON.parse(w.sessionStorage.getItem(storageKey));
      const token = new URL(w.location.href).searchParams.get('cartEdit');
      return c && c.token === token && c.path === w.location.pathname && Date.now() - c.at < 7200000 ? c : null;
    } catch (_) { return null; }
  }
  function clear() {
    w.sessionStorage.removeItem(storageKey);
    const u = new URL(w.location.href); u.searchParams.delete('cartEdit'); w.history.replaceState({}, '', u);
  }
  function url(ring, diamond) {
    const u = new URL(ring.url, w.location.origin), s = specification(ring, diamond);
    if (u.origin !== w.location.origin || !u.pathname.startsWith('/products/') || !s.weight || !s.origin || !s.shape) return '';
    u.search = '';
    Object.entries({from:'engagement-rings',shapeActive:s.shape,natOrLab:s.origin,diamondColor:s.colour,diamondCleanlines:s.clarity,diamondSize:s.weight,colorOfGold:s.metal,typeOfGold:s.karat,stage:4,pb:0}).forEach(([k,v]) => { if (v !== '') u.searchParams.set(k,v); });
    return u.pathname + u.search;
  }
  function begin(ring, diamond, event) {
    event.preventDefault();
    const destination = url(ring, diamond);
    if (!destination) return;
    const token = w.crypto.randomUUID(), u = new URL(destination,w.location.origin);
    const c = {token,at:Date.now(),path:u.pathname,ring,diamond,spec:specification(ring,diamond)};
    try { w.sessionStorage.setItem(storageKey, JSON.stringify(c)); } catch (_) { return; }
    u.searchParams.set('cartEdit',token);
    w.location.assign(u.pathname+u.search);
  }
  function restore(vm) {
    const c = context(); if (!c) return;
    const p = c.ring.properties || {};
    const size = vm.sizeOfProductData.find(s => String(s.european_size) === c.spec.size.replace(/\s*EU\s*$/, '').trim());
    if (!vm.queryParams.sizeProduct && size) vm.sizeProduct = size.id;
    vm.sizeNotClosed = false;
    if (!size && (p._size_not_closed === true || p._size_not_closed === 'true')) vm.sizeNotClosed = true;
    if (c.spec.side) vm.targetCaratSizes = parseFloat(c.spec.side);
    vm.quantity = c.ring.quantity;
  }
  async function saveExistingSelection(vm, client) {
    const c=context(); if(!c) return false;
    const p=c.ring.properties || {}, s=c.spec;
    const size=vm.thisSize ? vm.thisSize.european_size+' EU' : 'לא סגור על המידה';
    const sameSelection=Number(vm.getVariant.id)===Number(c.ring.variant_id) && Number(vm.diamondSize)===Number(s.weight) && vm.diamondColor===s.colour && vm.diamondCleanlines===s.clarity && vm.natOrLab===s.origin && vm.filterAttrDiamondShape===s.shape;
    if(!sameSelection) return false;
    const root=(w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
    const cart=(await client.get(root+'cart.js')).data;
    if(!cart.items.some(i=>i.key===c.ring.key && i.quantity===c.ring.quantity) || !cart.items.some(i=>i.key===c.diamond.key && i.quantity===c.diamond.quantity)) throw new Error('stale_cart');
    if(size!==s.size) {
      const properties=Object.assign({},p,{'גודל':size,'_size_not_closed':vm.sizeNotClosed});
      const changed=(await client.post(root+'cart/change.js',{id:c.ring.key,quantity:c.ring.quantity,properties})).data;
      const ring=changed.items.find(i=>Number(i.variant_id)===Number(c.ring.variant_id) && i.quantity===c.ring.quantity && Object.entries(properties).every(([key,value])=>text((i.properties || {})[key])===text(value)));
      const others=cart.items.filter(i=>i.key!==c.ring.key);
      if(!ring || changed.items.length!==cart.items.length || !others.every(old=>changed.items.some(i=>i.key===old.key && i.quantity===old.quantity))) throw new Error('size_update_not_confirmed');
    }
    clear(); return true;
  }
  async function submit(data, client, editing) {
    const c = context();
    const root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
    if (!c) { if(editing) throw new Error('missing_edit'); return client.post(root+'cart/add.js',data); }
    const current = (await client.get(root+'cart.js')).data;
    const oldRing = current.items.find(i => i.key === c.ring.key);
    const oldDiamond = current.items.find(i => i.key === c.diamond.key);
    if (!oldRing || !oldDiamond || oldRing.quantity !== c.ring.quantity || oldDiamond.quantity !== c.diamond.quantity) throw new Error('stale_cart');
    const shared = current.items.some(i => i.key !== oldRing.key && text((i.properties || {})._diamond_var_id) === text(oldDiamond.variant_id));
    if (shared) throw new Error('shared_diamond');
    const marker = w.crypto.randomUUID();
    data.items.forEach(i => { i.quantity = c.ring.quantity; i.properties = Object.assign({},i.properties,{_joolme_edit:marker}); });
    data.items[0].properties = Object.assign({},oldRing.properties,data.items[0].properties);
    // Engraving lives in the Israeli cart, not the PDP. Preserve it across ring edits.
    for (const key of ['חרוט טקסט','_engrave_font','_engrave_active']) {
      if (Object.prototype.hasOwnProperty.call(oldRing.properties || {},key)) data.items[0].properties[key]=oldRing.properties[key];
    }
    try {
      await client.post(root+'cart/add.js', data);
      const afterAdd = (await client.get(root+'cart.js')).data;
      const added = afterAdd.items.filter(i => (i.properties || {})._joolme_edit === marker);
      if (added.length !== data.items.length) throw new Error('edit_not_confirmed');
      const updated = await client.post(root+'cart/update.js',{updates:{[oldRing.key]:0,[oldDiamond.key]:0}});
      if (updated.data.items.some(i => i.key === oldRing.key || i.key === oldDiamond.key)) throw new Error('old_item_remaining');
      clear();
      return updated;
    } catch (error) {
      const now = (await client.get(root+'cart.js')).data;
      if (now.items.some(i => i.key === oldRing.key) && now.items.some(i => i.key === oldDiamond.key)) {
        const updates = {};
        now.items.filter(i => (i.properties || {})._joolme_edit === marker).forEach(i => {updates[i.key]=0;});
        if (Object.keys(updates).length) await client.post(root+'cart/update.js',{updates});
      }
      throw error;
    }
  }
  w.JoolmeCartClarity = {specification,context,url,begin,restore,submit,saveExistingSelection,unchanged:saveExistingSelection,
    title:ring => text((ring.properties || {})._name || ring.product_title).split(' - ')[0].replace(/\s+Engagement Ring$/i,''),
    metal:ring => {const s=specification(ring);return [s.karat,s.metal.replace(/_/g,' ')].filter(Boolean).join(' ');},
    side:ring => specification(ring).side,
    size:ring => specification(ring).size,
    diamond:diamond => {const s=specification({properties:{}},diamond);return [s.weight ? s.weight+' ct' : '',s.shape,s.origin==='Lab'?'Lab-grown':s.origin,s.colour,s.clarity].filter(Boolean).join(' · ');}
  };
})(window);
